import React, {Component} from "react";
import classes from './Home.module.css';
import ProfessionalSummary from "../../components/ProfessionalSummary/ProfessionalSummary";
import MyRoles from '../../components/MyRoles/MyRoles';
import {Grid, Slide} from "@material-ui/core";
import Education from "../../components/Education/Education";

class Home extends Component {
	render() {
		return (
			<Slide direction="left" timeout={500} in={true} mountOnEnter unmountOnExit>
				<div className={classes.Home}>
					<ProfessionalSummary/>
					<MyRoles/>
					<Grid container al>
						<Grid item xs={12}>
							<Education/>
						</Grid>
					</Grid>
				</div>
			</Slide>
		)
	}
}

export default Home;